export const SERVICE_MODALITIES = [
  { value: 'home', name: 'A domicilio' },
  { value: 'online', name: 'Online' },
  { value: 'onsite', name: 'Presencial' },
];

export const NUTRITIONISTS_FILTERS = {
  fitnessGoals: {
    name: 'Complementar mi proceso fitness',
    options: [],
  },
  goodLooking: {
    name: 'Verme o sentirme mejor',
    options: [
      {
        name: 'Control de peso',
        value: 'weight-control',
        specialties: [
          {
            name: 'Control de peso',
            key: 'weigth-control',
            type: 'keySpecialities',
          },
          {
            name: 'Aumento de masa',
            key: 'muscle-gain',
            type: 'keySpecialities',
          },
        ],
      },
      {
        name: 'Hábitos saludables',
        value: 'healty-habits',
        specialties: [
          {
            name: 'Nutriólogo general',
            key: 'general',
            type: 'nutriTypes',
          },
          {
            name: 'Hábitos saludables',
            key: 'healty-habits',
            type: 'keySpecialities',
          },
          {
            name: 'Health coaching',
            key: 'health-coaching',
            type: 'keySpecialities',
          },
        ],
      },
      {
        name: 'Psicología de los alimentos',
        value: 'food-psicology',
        specialties: [
          {
            name: 'Psicología de los alimentos',
            key: 'food-psicology',
            type: 'keySpecialities',
          },
          {
            name: 'Bulímia, anorexia',
            key: 'food-desorders',
            type: 'keySpecialities',
          },
        ],
      },
      {
        name: 'Desordenes alimenticios',
        value: 'food-desorders',
        specialties: [
          {
            name: 'Psicología de los alimentos',
            key: 'food-psicology',
            type: 'keySpecialities',
          },
          {
            name: 'Bulímia, anorexia',
            key: 'food-desorders',
            type: 'keySpecialities',
          },
        ],
      },
      {
        name: 'Cambiar mi tipo de dieta por razones éticas/filosofía',
        value: 'etical-changes',
        specialties: [],
      },
    ],
  },
  revertSyntoms: {
    name: 'Revertir o mejorar mis síntomas',
    options: [
      {
        name: 'Digestivos',
        value: 'digestive',
        specialties: [
          {
            name: 'Nutriólogo general',
            key: 'general',
            type: 'nutriTypes',
          },
          {
            name: 'Problemas gastrointestinales',
            key: 'gastro-issues',
            type: 'keySpecialities',
          },
          {
            name: 'Medicina funcional',
            key: 'functional-medicine',
            type: 'keySpecialities',
          },
        ],
      },
      {
        name: 'Hormonales',
        value: 'hormonal',
        specialties: [
          {
            name: 'Enfermedades tiroideas',
            key: 'thyroid',
            type: 'keySpecialities',
          },
          {
            name: 'Balance hormonal',
            key: 'hormonal-balance',
            type: 'keySpecialities',
          },
          {
            name: 'Medicina funcional',
            key: 'functional-medicine',
            type: 'keySpecialities',
          },
        ],
      },
      {
        name: 'Dermatológicos',
        value: 'dermatology',
        specialties: [
          {
            name: 'Dermatología',
            key: 'dermatology',
            type: 'keySpecialities',
          },
          {
            name: 'Alergias / intolerancias alimenticias',
            key: 'alergies',
            type: 'keySpecialities',
          },
        ],
      },
      {
        name: 'Alergias y/o intolerancias alimenticias',
        value: 'alergies',
        specialties: [
          {
            name: 'Alergias / intolerancias alimenticias',
            key: 'alergies',
            type: 'keySpecialities',
          },
          {
            name: 'Problemas gastrointestinales',
            key: 'gastro-issues',
            type: 'keySpecialities',
          },
          {
            name: 'Medicina funcional',
            key: 'functional-medicine',
            type: 'keySpecialities',
          },
        ],
      },
      {
        name: 'Hipertensión',
        value: 'hipertension',
        specialties: [
          {
            name: 'Nutriólogo clínico',
            key: 'clinical-nutrition',
            type: 'nutriTypes',
          },
          {
            name: 'Hipertensión',
            key: 'hipertension',
            type: 'keySpecialities',
          },
          {
            name: 'Medicina funcional',
            key: 'functional-medicine',
            type: 'keySpecialities',
          },
        ],
      },
      {
        name: 'Desordenes alimenticios',
        value: 'food-desorders',
        specialties: [
          {
            name: 'Psicología de los alimentos',
            key: 'food-psicology',
            type: 'keySpecialities',
          },
          {
            name: 'Bulímia, anorexia',
            key: 'food-desorders',
            type: 'keySpecialities',
          },
        ],
      },
      {
        name: 'Sistema inmunológico',
        value: 'immune',
        specialties: [
          {
            name: 'Inmonutrición',
            key: 'inmunonutrition',
            type: 'keySpecialities',
          },
          {
            name: 'Nutriólogo clínico',
            key: 'clinical-nutrition',
            type: 'nutriTypes',
          },
        ],
      },
      {
        name: 'COVID-19',
        value: 'covid-19',
        specialties: [
          { name: 'COVID-19', key: 'covid-19', type: 'keySpecialities' },
          {
            name: 'Inmonutrición',
            key: 'inmunonutrition',
            type: 'keySpecialities',
          },
          {
            name: 'Nutriólogo clínico',
            key: 'clinical-nutrition',
            type: 'nutriTypes',
          },
        ],
      },
    ],
  },
  medicalTreatment: {
    name: 'Complementar mi tratamiento médico',
    options: [
      {
        name: 'Diabetes',
        value: 'diabetes',
        specialties: [
          {
            name: 'Educador en diabetes',
            key: 'diabetes-education',
            type: 'keySpecialities',
          },
          {
            name: 'Nutriólogo clínico',
            key: 'clinical-nutrition',
            type: 'nutriTypes',
          },
        ],
      },
      {
        name: 'Desnutrición/anemia',
        value: 'malnutrition',
        specialties: [
          {
            name: 'Nutriólogo clínico',
            key: 'clinical-nutrition',
            type: 'nutriTypes',
          },
        ],
      },
      {
        name: 'Cáncer/oncología',
        value: 'cancer',
        specialties: [
          {
            name: 'Cáncer y oncología',
            key: 'cancer-oncology',
            type: 'keySpecialities',
          },
          {
            name: 'Nutriólogo clínico',
            key: 'clinical-nutrition',
            type: 'nutriTypes',
          },
        ],
      },
      {
        name: 'Riñones/enfermedad renal',
        value: 'renal',
        specialties: [
          {
            name: 'Enfermedad renal',
            key: 'renal-desease',
            type: 'keySpecialities',
          },
          {
            name: 'Nutriólogo clínico',
            key: 'clinical-nutrition',
            type: 'nutriTypes',
          },
        ],
      },
      {
        name: 'Hígado/enfermedad hepática',
        value: 'hepatic',
        specialties: [
          {
            name: 'Enfermedad hepática',
            key: 'hepatic-desease',
            type: 'keySpecialities',
          },
          {
            name: 'Alergias/intolerancias alimenticias',
            key: 'alergies',
            type: 'keySpecialities',
          },
        ],
      },
      {
        name: 'Corazón/cardiología',
        value: 'cardiology',
        specialties: [
          {
            name: 'Enfermedad cardiaca',
            key: 'cardiac-desease',
            type: 'keySpecialities',
          },
          {
            name: 'Nutriólogo clínico',
            key: 'clinical-nutrition',
            type: 'nutriTypes',
          },
        ],
      },
      {
        name: 'Cirugía bariátrica',
        value: 'bariatic',
        specialties: [
          {
            name: 'Cirugía bariátrica',
            key: 'bariatric-surgery',
            type: 'keySpecialities',
          },
        ],
      },
      {
        name: 'Gastrointestinal',
        value: 'gastro',
        specialties: [
          {
            name: 'Problemas gastrointestinales',
            key: 'gastro-issues',
            type: 'keySpecialities',
          },
          {
            name: 'Medicina funcional',
            key: 'functional-medicine',
            type: 'keySpecialities',
          },
        ],
      },
      {
        name: 'COVID-19',
        value: 'covid-19',
        specialties: [
          { name: 'COVID-19', key: 'covid-19', type: 'keySpecialities' },
          {
            name: 'Inmunonutrición',
            key: 'inmunonutrition',
            type: 'keySpecialities',
          },
          {
            name: 'Nutriólogo clínico',
            key: 'clinical-nutrition',
            type: 'nutriTypes',
          },
        ],
      },
      {
        name: 'Dermatológicos',
        value: 'dermatologic',
        specialties: [
          {
            name: 'Dermatología',
            key: 'dermatology',
            type: 'keySpecialities',
          },
          {
            name: 'Medicina funcional',
            key: 'functional-medicine',
            type: 'keySpecialities',
          },
        ],
      },
      {
        name: 'Hormonal',
        value: 'hormonal',
        specialties: [
          {
            name: 'Balance hormonal/endocrino',
            key: 'hormonal-balance',
            type: 'keySpecialities',
          },
          {
            name: 'Enfermedades tiroideas',
            key: 'thyroid',
            type: 'keySpecialities',
          },
          {
            name: 'Síndrome de ovario poliquístico (SOP)',
            key: 'sop',
            type: 'keySpecialities',
          },
        ],
      },
      {
        name: 'Reumatología',
        value: 'reumatologic',
        specialties: [
          {
            name: 'Reumatología',
            key: 'reaumatology',
            type: 'keySpecialities',
          },
          {
            name: 'Nutriólogo clínico',
            key: 'clinical-nutrition',
            type: 'nutriTypes',
          },
        ],
      },
      {
        name: 'Terapia intensiva',
        value: 'therapyIntensive',
        specialties: [
          {
            name: 'Terapia intensiva',
            key: 'intensive-care',
            type: 'keySpecialities',
          },
          {
            name: 'Nutriólogo clínico',
            key: 'clinical-nutrition',
            type: 'nutriTypes',
          },
        ],
      },
      {
        name: 'Nutrición entenal',
        value: 'etenalNutrition',
        specialties: [
          {
            name: 'Nutrición entenal',
            key: 'enteral-nutrition',
            type: 'keySpecialities',
          },
          {
            name: 'Nutriólogo clínico',
            key: 'clinical-nutrition',
            type: 'nutriTypes',
          },
        ],
      },
      {
        name: 'Nutrición parenteral',
        value: 'prenatal',
        specialties: [
          {
            name: 'Nutrición parenteral',
            key: 'parenteral-nutrition',
            type: 'keySpecialities',
          },
          {
            name: 'Nutriólogo clínico',
            key: 'clinical-nutrition',
            type: 'nutriTypes',
          },
        ],
      },
    ],
  },
  olderPeople: {
    name: 'Nutrición del adulto mayor',
    options: [],
    extra: [
      {
        name: 'Tercera edad/geriatría',
        key: 'old-geriatry',
        type: 'keySpecialities',
      },
    ],
  },
  pregnancy: {
    name: 'Nutrición en embarazo y/o lactancia',
    options: [],
    extra: [
      {
        name: 'Embarazo y lactancia',
        key: 'pregnancy-breast-feed',
        type: 'keySpecialities',
      },
    ],
  },
  corporate: {
    name: 'Programas para empresas/corporativos',
    options: [],
  },
  baby: {
    name: 'Nutrición del bebé o niño',
    options: [],
    extra: [
      {
        name: 'Pediatría',
        key: 'pedatry',
        type: 'keySpecialities',
      },
      {
        name: 'Baby-led weaning',
        key: 'baby-weaning',
        type: 'keySpecialities',
      },
      {
        name: 'Embarazo y lactancia',
        key: 'pregnancy-breast-feed',
        type: 'keySpecialities',
      },
    ],
  },
};
